/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';
import { JOB_FIELDS } from '../../fragments';
import { AddJobProps, UpdateJobProps } from './job.types';
import { JobType } from '../../../types';
import { GET_DEPARTMENT_BY_ID, GET_JOB_BY_ID } from '../../queries';

export const ADD_JOB = gql`
  ${JOB_FIELDS}
  mutation AddJob(
  $referenceId: ID!,
  $title: String!,
  $description: String!,
  $employmentType: String!,
  $salary: Float!,
  $level: Int!) {
    addJob(
    referenceId: $referenceId,
    title: $title,
    description: $description,
    employmentType: $employmentType,
    salary:$salary,
    level: $level
    
    ){
      ...JobFields
    }
  }
`;

export function addJob({
  client,
  referenceId,
  title,
  description,
  employmentType,
  salary,
  level,
}: AddJobProps) {
  return client?.mutate<{ addJob: JobType }>({
    mutation: ADD_JOB,
    variables: {
      referenceId,
      title,
      description,
      employmentType,
      salary,
      level,
    },
    refetchQueries: [
      GET_DEPARTMENT_BY_ID,
    ],
  });
}

export const UPDATE_JOB = gql`
  ${JOB_FIELDS}
  mutation UpdateJob(
  $jobId:ID!,
  $referenceId: ID,
  $title: String,
  $description: String,
  $employmentType: String,
  $salary: Float,
  $level: Int,
  ){
    updateJob(
    jobId:$jobId,
    referenceId:$referenceId,
    title:$title,
    description:$description,
    employmentType:$employmentType,
    salary:$salary,
    level: $level 
    ){
      ...JobFields
    }
  }
`;

export function updateJob({
  client,
  referenceId,
  title,
  description,
  employmentType,
  salary,
  level,
}: UpdateJobProps) {
  return client?.mutate<{ addJob: JobType }>({
    mutation: UPDATE_JOB,
    variables: {
      referenceId,
      title,
      description,
      employmentType,
      salary,
      level,
    },
    refetchQueries: [
      GET_JOB_BY_ID,
    ],
  });
}
